/**
 * Simple Collections Custom Element
 * Handles auto-scrolling to active collection on mobile
 */

class SimpleCollections extends HTMLElement {
  constructor() {
    super();

    // On mobile, scroll to the active collection item after a delay
    if (window.matchMedia('(max-width: 749px)').matches) {
      setTimeout(() => {
        const activeItem = this.querySelector('.simple-collections__item--active');
        if (activeItem) {
          const left = activeItem.getBoundingClientRect().left;
          this.scrollBy({ left, behavior: 'smooth' });
        }
      }, 1000);
    }
  }
}

if (!customElements.get('simple-collections')) {
  customElements.define('simple-collections', SimpleCollections);
}
